import { observable, action, computed, flow } from 'mobx';
import { Toast, Modal } from 'antd-mobile';

import utils from 'utils';
import { rstr2b64, hex_md5, Encrypts } from 'utils/md5';
import Stores from 'config/Stores';
import Config from 'config/Config';
import Serv from './AgentRegisterServ';
import { popupPositionMap } from 'utils/constants';
import { fetchData } from 'pubBiz/ActiveAdPopup/fetchData';

const Alert = Modal.alert;

class AgentRegisterMod {
  // uniqueId, 获取验证码时，后台返回的，用于后台校验
  @observable uniqueId = '';

  @observable phone = '';
  // @observable userName = '';

  @observable code = '';

  @observable codeLoading = false;

  // 是否同意协议
  @observable isAgree = false;

  @observable cardNum = '';

  @observable password = '';

  @observable healthy = '';

  @observable sale = '';

  @observable saleCardInfoName = '';

  @observable usedPhysical = false;

  @observable editSign = true;

  @observable isAllowAlterRelationState = false;
  @observable isNewMember = true; //是否为新客，没注册过
  @observable phoneBelongSystem = ''; //手机号对应的站点
  @observable healthConsultantNum = ''; //手机号码的健康顾问

  // 是否需要注册订单
  @observable needRegisterOrder = 0;

  // 无需注册时的开卡订单id
  @observable registerCardTypeId = '';

  @observable showCardTip = false;
  @observable infoData = {};

  @observable areaCode = Stores.AppMod.isInternationalized ? 1 : 86;

  //是否为乐道大单跳转
  ldOrder = '';

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 重置数据
   */
  @action
  clearData() {
    this.uniqueId = '';
    this.code = '';
    // this.userName = '';
    this.codeLoading = false;
    this.isAgree = false;
    this.isAllowAlterRelationState = false;
    this.isNewMember = false;
    this.phoneBelongSystem = '';
    this.healthConsultantNum = '';
    this.showCardTip = false;
    this.infoData = {};
  }

  /**
   * 获取验证码
   */
  getVerifyCode = flow(function* (extObj, verifyCodeData) {
    const timestamp = new Date().getTime();
    try {
      if (this.codeLoading) return;
      this.codeLoading = true;
      let params = {
        healthConsultantNum: this.healthy,
        phone: this.phone,
        descriptionType: 10, // 10 - 代客注册
        codeType: 2, // 1 - 图像验证码，2 - 手机验证码，3 - 邮箱验证码
        md5Sign: encodeURIComponent(
          Encrypts(
            timestamp + '#' + hex_md5(this.phone.replace(/\s*/g, '') + utils.getSendMsgParamsUat()).toUpperCase()
          )
        ),
        areaCode: Stores.AppMod.areaCode
      };
      let data = {},
        resultMsg = '',
        resultCode = '';
      if (verifyCodeData) {
        data = verifyCodeData.data;
        resultMsg = verifyCodeData.resultMsg;
        resultCode = verifyCodeData.resultCode;
      } else {
        const res = yield Serv.getVerifyCode(params);
        data = res.data;
        resultMsg = res.resultMsg;
        resultCode = res.resultCode;
      }
      this.codeLoading = false;
      if (resultCode != '0') {
        Toast.fail(resultMsg, 1);
        return null;
      }
      if (data && data.uniqueId) {
        !verifyCodeData && Toast.info(resultMsg, 2);
        this.uniqueId = data.uniqueId;
        if (data.healthConsultantNum) {
          this.healthy = data.healthConsultantNum;
          if (data.healthConsultantNum != '8888888888') {
            this.editSign = false;
          }
        }
        return data;
      }
      return null;
    } catch (error) {
      return null;
    }
  });

  /**
   * 获取销售顾问姓名
   *
   * @memberof RegisterMod
   */
  getSaleCardCodeName = flow(function* (cardCode) {
    const { data } = yield Serv.getCardCodeName(cardCode);
    this.saleCardInfoName = data || '不存在';
  });

  applyPhysicalCard = flow(function* () {
    const { cardNum, password } = this;
    try {
      const params = {
        cardCode: cardNum,
        password: rstr2b64(password)
      };
      const result = yield Serv.applyPhysicalCard(params);
      return result;
    } catch (error) {}
  });

  /**
   * 注册
   * @param {String} healthConsultantNum 虚拟资格 代客注册 健康顾问 当前用户
   */
  register = flow(function* ({ disallowModifyHealth }) {
    const bindCardCode = utils.getLocalCache('bindCardCode') || '';
    const { saleZone = '' } = Stores.AppMod.userInfo || {};
    // 是否需要验证码 1 需要 0 不需要
    // const { memberValetVerificationCode } = Stores.AppMod.userInfo
    try {
      const helthyCodeVal = utils.getLocalCache('isVirtualPoint')
        ? Stores.AppMod.userInfo.cardCode
        : this.healthy;
      // const {data: $data } = yield Serv.getCardCodeInfo({cardCode: helthyCodeVal, register: true});
      // const { registerCardTypeId } = $data || {};
      let params = {
        phone: this.phone,
        // ...(Stores.AppMod.userInfo.belongSystem=='LY'?{
        //   userName: this.userName,

        // }:{}),
        uniqueId: this.uniqueId,
        verifyCode: this.code,
        healthConsultantNum: utils.getLocalCache('isVirtualPoint')
          ? Stores.AppMod.userInfo.cardCode
          : this.healthy,
        applicationType: 1,
        codeType: 2,
        channel: 3, // H5渠道
        customerSource: utils.isWeiXin() ? 1 : 5, // 微信 - 0，非微信打开 - 4
        areaCode: Stores.AppMod.areaCode || '86'
      };
      if (utils.getLocalCache('isVirtualPoint')) {
        params.virtualPointTag = 1;
      }
      // if (bindCardCode.includes('LSH') && this.sale) {
      //   params.saleConsultantNum = this.sale;
      // }
      // registerCardTypeId && (params.cardTypeId = registerCardTypeId);
      const { data, resultMsg } = yield Serv.register(params);
      // if(data&&Stores.AppMod.userInfo.belongSystem=='LY'){
      //   Util.setLocalCache('LYuserName', this.userName)
      // }
      localStorage.setItem('dgAreaCode', data.areaCode || 86);
      localStorage.setItem('cloudUserId', data.id);

      // 神策数据发送
      window.sensors.track('register', { phone: params.phone });
      if (saleZone && data.passwordForThird) {
        // 销售专区
        this.changeState('showCardTip', true);
        this.changeState('infoData', data || {});
        return;
      }

      //乐道大单特殊处理
      if (this.ldOrder) {
        this.ldOrderApply(data);
        return;
      }
      // 虚拟资格使用
      if (utils.getLocalCache('isVirtualPoint')) {
        this.useVirtual({
          ...data,
          disallowModifyHealth
        });
        return;
      }
      // 如果有卡号 就走代客升级逻辑
      // if (data.cardCode) {
      //   let $realName = data.phone;
      //   if(!!data.phone && data.phone.indexOf('*') != -1) {
      //   // 解密姓名
      //     params.realName = yield Stores.AppMod.getDecyptMsg({
      //       cardCode: data.cardCode || '',
      //       scene: 101,
      //       channel: '',
      //     })
      //   }
      //   utils.setLocalCache(Config.localStorageKeys.store_agentUpgradeMember, {
      //     cardCode: data.cardCode,
      //     realName: $realName,
      //     dgUserId: data.id,
      //   });
      //   utils.setLocalCache('memberForUpdate', true);
      //   const goNextFun = () => {
      //     this.getUpgradeTypeList({
      //       cardCode: data.cardCode,
      //       realName: $realName,
      //     });
      //   };
      //   Stores.AppMod.confirmUpdate({
      //     cardCode: data.cardCode,
      //     goNextFun,
      //     phone: data.phone,
      //     registerTime: data.registerTime,
      //     password: data.extension,
      //     domId: 'menberHelpUpgrade',
      //   });
      //   return;
      // }
      // this.queryCanApplyType(data.id, data.healthConsultantNum, params.phone);
      // 获取卡类型
      this.agentApply({
        agentId: data.id,
        healthConsultantNum: data.healthConsultantNum,
        data
      });
      return true;
    } catch (error) {}
  });

  // 获取升级卡类型
  getUpgradeTypeList = ({ cardCode, realName }) => {
    Toast.loading();
    this.getCardTypeList({ cardCode, realName }).then((ret) => {
      window.app.routerGoTo({
        pathname: '/register/memGiftbag',
        clear: false,
        state: {
          HealthyCardCode: cardCode,
          memberForUpdate: true,
          applyType: 4,
          fromSource: ''
        }
      });
      Toast.loading();
    });
    setTimeout(() => {
      Toast.hide();
    }, 3000);
  };

  /**
   * 获取老客升级卡类型列表 and 维多益站点会员个人在“我的”中增加代客升级功能
   */
  getCardTypeList = flow(function* ({ cardCode, realName }) {
    try {
      let params = {};
      let url = 'user/upgrade/queryCardType';
      params = {
        bizUpgradeCardReqDto: {
          channel: 4,
          cardCode
        }
      };
      const { data, resultCode } = yield Serv.getCardTypeList(url, params);
      const cardTypeList = data || [];
      utils.setLocalCache(Config.localStorageKeys.store_agentUpgradeMember, {
        cardCode,
        realName
      });
      let shop_checkOrderParams =
        utils.getLocalCache(Config.localStorageKeys.shop_checkOrderParams) || {};
      shop_checkOrderParams.dgMemberInfo = {
        memberCard: cardCode || '',
        memberName: realName,
        cardType: 0,
        origin: 'shop'
      };
      utils.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, shop_checkOrderParams);
      utils.setLocalCache(Config.localStorageKeys.member_cardTypeData, cardTypeList);
      return resultCode;
    } catch (error) {}
  });

  ldOrderApply = (data) => {
    utils.setLocalCache(Config.localStorageKeys.member_agentApplyCardMsg, {
      healthConsultantNum: data.healthConsultantNum,
      helpUserId: data.id,
      isEntityCard: this.usedPhysical ? 1 : 0, // 虚拟卡
      channel: 2,
      agree: this.isAgree
    });

    utils.setLocalCache(Config.localStorageKeys.menber_helpUserId, {
      agentId: data.id,
      phone: this.phone,
      healthConsultantNum: data.healthConsultantNum // 健康顾问信息
    });

    //跳转到补充资料界面
    window.app.routerGoTo({
      pathname: '/register/memCardMsg',
      clear: true,
      state: {
        // '7'代表店铺新客注册类型的礼包选购
        applyType: '5',
        ldOrder: true
      }
    });
  };

  useVirtual = (data) => {
    if (data) {
      console.log('asdasdasd667', data);
      utils.setLocalCache('virtualUserId', data.id);
      utils.setLocalCache('shareSaleCardCode', ''); // 清空分享销售顾问
      utils.setLocalCache(Config.localStorageKeys.share_link_Id, ''); // 清空分局分享shareId
      let callback = null;

      console.log(
        '注册获取',
        utils.getLocalCache('virtualNeedOrder'),
        utils.getLocalCache('virtualFreeFreight'),
        utils.getLocalCache('virtualUserId')
      );
      if (utils.getLocalCache('virtualNeedOrder') == 1) {
        const { isAgree: agree, healthy: healthConsultantNum, usedPhysical } = this;
        const { id, cardCode, realName } = data;
        // 存入代客情况下传客的信息
        utils.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
          dgUserId: id,
          dgMemberInfo: {
            memberCard: cardCode,
            memberName: realName,
            origin: 'member'
          }
        });
        utils.setLocalCache(Config.localStorageKeys.menber_helpUserId, {
          agentId: id,
          phone: this.phone,
          healthConsultantNum // 健康顾问信息
        });
        // 使用虚拟资格 注册开卡 需要订单 跳转产品选购页
        callback = () => {
          window.app.routerGoTo({
            pathname: '/register/memGiftbag',
            clear: true,
            state: {
              applyType: '3'
            }
          });
        };
      } else {
        // 不需要订单
        callback = () => {
          window.app.routerGoTo({
            pathname: '/register/memCardMsg',
            state: {
              id: data.id,
              applyType: '',
              disallowModifyHealth: data.disallowModifyHealth
            }
          });
        };
      }
      fetchData(
        { popupPosition: popupPositionMap.REGISTRATION_COMPLETED },
        () => {
          callback();
        },
        () => {
          callback();
        }
      );
    }
  };

  /**
   * 查询是否可开实体卡或虚拟卡
   * @param {String} agentId - A代B开卡，B的userId
   * @param {String} healthy - A代B开卡，B的健康顾问
   */
  queryCanApplyType = flow(function* (agentId, healthy, phone) {
    try {
      const params = {
        channel: 2,
        healthConsultantCardCode: healthy,
        valetCardCode: Stores.AppMod.userInfo.cardCode
      };
      const { data } = yield Serv.queryCanApplyType(params);
      const object = {
        applyType: '5',
        agentId,
        healthy,
        phone
      };
      // 0 - 只能开虚拟卡，1 - 只能开实体卡，2 - 可开虚拟卡或实体卡
      // if (data != 0) {
      //   // ignoreFictitious: 是否不可开虚拟卡
      //   window.app.routerGoTo({
      //     pathname: '/register/physicalCard',
      //     clear: true,
      //     state: {
      //       ignoreFictitious: data == 1,
      //       applyType: '5',
      //       agentId,
      //       healthy,
      //       phone,
      //     },
      //   });
      // } else {
      //   window.app.routerGoTo({
      //     pathname: '/register/memCardMsg',
      //     clear: true,
      //     state: {
      //       applyType: '5',
      //       agentId,
      //       healthy,
      //       phone,
      //     },
      //   });
      // }
    } catch (error) {}
  });

  /**
   * 获取注册须知协议
   */
  getNoticeAgreement = flow(function* () {
    try {
      const { data } = yield Serv.getAgreement('registration');
      // 保存时，处理图文详情信息，将px转成rem
      this.noticeContent = utils.changeRichText(data.content);
      this.disableNotice = data.status == 0;
    } catch (error) {}
  });

  /**
   * 按钮是否不可点
   */
  @computed get disabled() {
    console.log('salesalesale', this.sale);

    // 是否需要验证码 1 需要 0 不需要
    const { memberValetVerificationCode } = Stores.AppMod.userInfo;
    return (
      !(
        (memberValetVerificationCode === 0 ? true : this.uniqueId && this.code.length > 3) &&
        (Stores.AppMod.areaCode != 86 ? true : utils.checkInput(this.phone, 'mobile'))
      ) ||
      (!this.disableNotice && !this.isAgree)
    );
  }

  // 麟莎站点，注册需要填写正确健康顾问、销售顾问
  // @computed get saleInCorrect() {
  //   const bindCardCode = utils.getLocalCache('bindCardCode') || '';
  //   const { saleName, healthyName, healthyStatus } = Stores.MemCardMsgMod;
  //   if (!bindCardCode) return true;
  //   return (
  //     bindCardCode &&
  //     (!bindCardCode.includes('LSH') ||
  //       (bindCardCode.includes('LSH') && this.sale && saleName && healthyName && healthyStatus))
  //   );
  // }

  /**
   * 校验实体卡号和密码
   */
  next = () => {
    const { applyType, phone, agentId, healthy, cardNum, password, isInvite } = this.state;
    const { usedPhysical } = this;
    switch (`${applyType}`) {
      case '7': {
        // 店铺新客注册场景校验实体卡密
        if (!usedPhysical) {
          window.app.routerGoTo({
            pathname: '/store/businessManage/storeAgentMsg',
            clear: true,
            state: { applyType, agentId, healthy, phone }
          });
          return;
        }
        this.storeAgentRegStore.applyPhysicalCard(
          cardNum,
          password,
          applyType,
          agentId,
          healthy,
          phone
        );
        break;
      }
      default: {
        // 其他场景校验实体卡密
        if (!usedPhysical) {
          window.app.routerGoTo({
            pathname: `/register/memCardMsg`,
            clear: true,
            state: { applyType, agentId, healthy, phone, isInvite }
          });
          return;
        }
        this.registerStore.applyPhysicalCard(
          cardNum,
          password,
          applyType,
          agentId,
          healthy,
          phone,
          isInvite
        );
      }
    }
  };

  /**
   * 新客注册信息提交，获取卡类型
   */
  agentApply = flow(function* (obj) {
    const { agentId, phone, data: agentData, disallowModifyHealth } = obj;
    const { isAgree: agree, healthy: healthConsultantNum, usedPhysical } = this;
    const { cardCode, realName, areaCode } = agentData || {};
    try {
      const params = {
        registerCardReqDto: {
          healthConsultantNum,
          helpUserId: agentId,
          isEntityCard: usedPhysical ? 1 : 0, // 虚拟卡
          channel: 2,
          agree,
          areaCode
        }
      };
      if (usedPhysical) {
        params.registerCardReqDto.entityCardCode = this.cardNum;
        params.registerCardReqDto.entityPassword = rstr2b64(this.password);
      }
      const { resultMsg, resultCode, data } = yield Serv.apply(params);
      this.clearData();
      if (resultCode == 9998) {
        this.initHealthy = '';
        this.healthy = '';
        this.getHealthyUser();
        Toast.fail('健康顾问已更新，请重新填写销售顾问~', 2);
        return;
      }
      if (resultCode != 0) {
        Toast.fail(resultMsg, 3);
        return;
      }
      // 神策数据发送
      window.sensors.track('registerMember', {});
      Toast.success('提交成功，选购礼包即可完成开卡', 1, () => {
        utils.setLocalCache(
          Config.localStorageKeys.member_agentApplyCardMsg,
          params.registerCardReqDto
        );
        utils.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);
        utils.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
          dgUserId: agentId,
          dgMemberInfo: {
            memberCard: cardCode,
            memberName: realName,
            origin: 'member'
          }
        });
        utils.setLocalCache(Config.localStorageKeys.menber_helpUserId, {
          agentId,
          phone: this.phone,
          healthConsultantNum // 健康顾问信息
        });
        utils.setLocalCache(Config.localStorageKeys.submitChannel, 1);

        window.app.routerGoTo({
          pathname: '/register/memGiftbag',
          clear: true,
          state: {
            // '5'代表会员新客注册类型的礼包选购
            applyType: '5',
            // memberForUpdate: true,
            HealthyCardCode: healthConsultantNum || '',
            // fromSource: 'store',
            disallowModifyHealth
          }
        });
      });
    } catch (error) {}
  });
}
const agentRegisterMod = new AgentRegisterMod();
export default agentRegisterMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/AgentRegister/AgentRegisterMod.js